module.exports = __webpack_public_path__ + "img/img1.a96f7588.jpg";